import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solucoes',
  templateUrl: './solucoes.component.html',
  styleUrls: ['./solucoes.component.css']
})
export class SolucoesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
